"use strict";
/**
 * Created by Marvin Ruppelt on 26.04.17.
 */
exports.__esModule = true;
var actionTypes_1 = require("../actions/actionTypes");
var modalReducer = function (state, action) {
    if (state === void 0) { state = {}; }
    switch (action.type) {
        case actionTypes_1.HIDE_MODAL:
            return {};
        case actionTypes_1.SHOW_MODAL:
            return { showModal: action.name };
        default:
            return state;
    }
};
exports["default"] = modalReducer;
